import { jsx as _jsx } from "react/jsx-runtime";
import backArrowIcon from '@ingka/ssr-icon/paths/arrow-left';
import reloadIcon from '@ingka/ssr-icon/paths/arrow-pair-squarepath';
import styled from 'styled-components';
import { SkapaButton, SkapaColors } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
const StyledErrorView = styled.div `
  height: 100dvh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;

  background-image: url(${props => props.$image});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: top;
  background-color: ${SkapaColors.colourStaticGrey};
`;
const StyledReloadButton = styled(SkapaButton) `
  & > span {
    background-color: ${SkapaColors.colourStaticWhite} !important;
  }
`;
const StyledButtonsContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  scale: ${props => (props.$isCompact ? 1 : 2)};
  row-gap: 24px;
`;
export const GuidaErrorReloadButton = ({ onClick, text }) => {
    return (_jsx(StyledReloadButton, { onClick: onClick, type: 'secondary', text: text, ssrIcon: reloadIcon, iconPosition: 'leading' }));
};
export const GuidaErrorExitButton = ({ onClick, text }) => {
    return (_jsx(SkapaButton, { onClick: onClick, type: 'primary', text: text, ssrIcon: backArrowIcon, iconPosition: 'leading', dataTestId: 'button-exit-application' }));
};
export const GuidaErrorOverlay = ({ children, image }) => {
    const { isCompact } = useGuidaUIStates();
    return (_jsx(StyledErrorView, { "$image": image, children: _jsx(StyledButtonsContainer, { "$isCompact": isCompact, children: children }) }));
};
//# sourceMappingURL=GuidaErrorView.js.map